// How a rule's finding reaches a person: its text comes from the rule's id, in their language. Never from the report's English `reason`.

/**
 * What a report stores as `match` when a rule fired on a condition rather than on words: technical, and in English.
 * A test ties this list to every rule's `gateMatch`, so a new one can't slip through to the screen.
 */
export const GATE_MATCHES: ReadonlySet<string> = new Set([
  "namesProvider",
  "ş/ţ",
  "provider depicted in promotional A/V",
  "doctor named",
  "countryCode",
  "vertical",
  "offer without validity",
  "alcohol and minors",
  "alcohol with a benefit",
  "roadworthiness date",
]);

/** The words the person wrote that tripped the rule, or null when the rule isn't about particular words. */
export function matchedWords(match: string | null | undefined): string | null {
  const words = match?.trim();
  return words && !GATE_MATCHES.has(words) ? words : null;
}

/** The rule ids in a refusal. Some routes send ids, others whole findings. Once each. */
export function brokenRuleIds(details: unknown): string[] {
  const list = (details as { violations?: unknown } | null | undefined)?.violations;
  if (!Array.isArray(list)) return [];
  const ids = list.flatMap((entry) => {
    const id = typeof entry === "string" ? entry : (entry as { id?: unknown } | null)?.id;
    return typeof id === "string" && id.includes(".") ? [id] : [];
  });
  return [...new Set(ids)];
}
